export const MENU_ITEMS_REFERENCE = {
    has_ap_objetivos: {
        hash: '#objetivo',
        id: 'objetivo',
        icone: require('@svgs/curso/pen.svg'),
        titulo: 'Objetivo',
        conteudo: 'ap_objetivos'
    },
    has_calendario_academico: {
        hash: '#calendario',
        id: 'calendario',
        icone: require('@svgs/curso/calendar.svg'),
        titulo: 'Calendário',
        conteudo: 'calendario_academico'
    },
    has_corpo_docente: {
        hash: '#corpo',
        id: 'corpo',
        icone: require('@svgs/curso/presentation.svg'),
        titulo: 'Corpo Docente',
        conteudo: 'corpo_docente'
    },
    has_parceiro: {
        hash: '#parceria',
        id: 'parceria',
        icone: require('@svgs/curso/handshake.svg'),
        titulo: 'Parceria',
        conteudo: 'parceiro.conteudo'
    },
    has_metodologia: {
        hash: '#metodologia',
        id: 'metodologia',
        icone: require('@svgs/curso/metodologia.svg'),
        titulo: 'Metodologia',
        conteudo: 'metodologia'
    },
    has_matriz_curricular: {
        hash: '#matriz',
        id: 'matriz',
        icone: require('@svgs/curso/grade.svg'),
        titulo: 'Grade Curricular',
        conteudo: 'matriz_curricular'
    },
    has_ap_investimento: {
        hash: '#investimento',
        id: 'investimento',
        icone: require('@svgs/curso/hand.svg'),
        titulo: 'Investimento',
        conteudo: 'ap_investimento'
    },
    has_contexto_social: {
        hash: '#contexto',
        id: 'contexto',
        icone: require('@svgs/curso/pen.svg'),
        titulo: 'Contexto Social',
        conteudo: 'contexto_social'
    },
    has_desenvolvimento_habilidades: {
        hash: '#habilidades',
        id: 'habilidades',
        icone: require('@svgs/curso/habilidade.svg'),
        titulo: 'Desen. de Habilidades',
        conteudo: 'desenvolvimento_habilidades'
    },
    has_exigencias_mercado: {
        hash: '#exigencias',
        id: 'exigencias',
        icone: require('@svgs/curso/suitcase.svg'),
        titulo: 'Exigências de mercado',
        conteudo: 'exigencias_mercado'
    },
    has_publico_alvo: {
        hash: '#publico',
        id: 'publico',
        icone: require('@svgs/curso/pen.svg'),
        titulo: 'Público-alvo',
        conteudo: 'publico_alvo'
    },
}

export const CURSOS_EDUCACAO_GRAD = [ '211', '212', '213' ]
export const CURSOS_TRANSFERENCIAS = [ '068', '069', '086', '087', '088' ]